module.exports = __webpack_public_path__ + "static/img/cicon53.878bfe0.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/connect/cicon53.png
// module id = Y7j+
// module chunks = 7